import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { Location } from "../utils/types/location";

export const fetchLocations = async () => {
  const response = await axiosServices.get(`/location`);
  return convertToCamelCase<Location[]>(response.data.data);
};

export type ServiceLocationUsage = "arrangement" | "cargo" | "husbandry";

export const fetchServiceLocations = async (
  usage: ServiceLocationUsage,
  portCallingsId?: string
) => {
  const response = await axiosServices.get(`/location`, {
    params: {
      ...(portCallingsId ? { portCallingsId } : {}),
      usage,
    },
  });
  return convertToCamelCase<Location[]>(response.data.data);
};

export const getLocationsList = async () => {
  const response = await axiosServices.get(`/location`);

  return response.data.data;
};

export const updateLocationData = async (
  id: string,
  data: {
    [key: string]: any;
    locationId: string;
  }
) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.put(`/location/${id}`, inputData);
  return convertToCamelCase<Location>(response.data.data);
};

export const deleteLocationListData = async (id: string) => {
  const response = await axiosServices.delete(`/location/${id}`);
  return { success: response.data.success, id };
};

export const addLocationData = async (data: { [key: string]: any }) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/location`, inputData);
  return convertToCamelCase<Location>(response.data.data);
};
